<div class="sidebar h-[600px] w-[250px] overflow-auto px-5 pt-4 lg:w-[300px]">
  <nav>
    @for (group of sidebarState.allRoutes; track $index) {
      <ul class="mt-4 list-none pl-0">
        <li class="mb-2 font-medium">{{ group.name }}</li>
        @for (link of group.statics; track $index) {
          <li>
            <a
              [routerLinkActive]="'selected'"
              class="sidebar-link my-3 ml-0 flex h-8 cursor-pointer items-center justify-between rounded-md pr-2 pl-4 hover:bg-slate-100"
              [routerLink]="['/doc/', group.name | lowercase, link.url]"
              >{{ link.name }}
            </a>
          </li>
        }

        @for (linkOrGroup of group.children; track $index) {
          @if ($any(linkOrGroup).children) {
            @let childGroup = $any(linkOrGroup);

            <li class="mb-2 pl-4 font-medium">{{ childGroup.name }}</li>

            <ul>
              @for (link of $any(childGroup).children; track $index) {
                <li>
                  <a
                    [routerLinkActive]="'selected'"
                    class="sidebar-link my-3 ml-0 flex h-8 cursor-pointer items-center justify-between rounded-md pr-2 pl-10 hover:bg-slate-100"
                    [routerLink]="['/doc/', group.name | lowercase, link.url]"
                    >{{ link.name }}
                    @if (link.mode === 'experimental') {
                      <span
                        class="inline-flex items-center gap-1 rounded-xl bg-slate-200 px-2 py-1 text-xs"
                      >
                        {{ link.mode }}
                      </span>
                    }
                  </a>
                </li>
              }
            </ul>
          } @else {
            @let link = $any(linkOrGroup);
            <li>
              <a
                [routerLinkActive]="'selected'"
                class="sidebar-link my-3 ml-0 flex h-8 cursor-pointer items-center justify-between rounded-md pr-2 pl-4 hover:bg-slate-100"
                [routerLink]="['/doc/', group.name | lowercase, link.url]"
                >{{ link.name }}
                @if (link.mode === 'experimental') {
                  <span
                    class="inline-flex items-center gap-1 rounded-xl bg-slate-200 px-2 py-1 text-xs"
                  >
                    {{ link.mode }}
                  </span>
                }
              </a>
            </li>
          }
        }
      </ul>
      <app-divider></app-divider>
    }
  </nav>
</div>
